import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/permission";

import "./styles/reset.scss";
import "./assets/fonts/iconfont";
import "./assets/Johnston100 W03 Medium/fonts.css";
import "./assets/Johnston100 W03 Regular/fonts.css";
import {
  Form,
  FormItem,
  Select,
  Option,
  Icon,
  Dialog,
  Button,
  Input,
  Upload,
  RadioGroup,
  Radio,
  RadioButton,
  DatePicker,
  Checkbox,
  CheckboxGroup,
  // Message,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Table,
  TableColumn,
  Pagination,
  Timeline,
  TimelineItem,
  Switch,
  Drawer,
  Tag,
  Loading,
  Col,
  Row,
  InputNumber,
  Link,
  Image,
} from "element-ui";
import {
  Tab,
  Tabs,
  Tabbar,
  TabbarItem,
  Popup,
  ContactCard,
  List,
  PullRefresh,
  Uploader,
  Calendar,
  Field,
  DatetimePicker,
  Picker,
  Search,
  Overlay,
  Collapse,
  CollapseItem,
  DropdownMenu,
  DropdownItem,
  Steps,
  Step,
  Area,
  Panel,
  Divider,
  Swipe,
  SwipeItem,
  Badge,
  TreeSelect,
  Empty,
  Rate,
  Cell,
  CellGroup,
  Icon as VantIcon,
  Form as VantForm,
  Switch as VantSwitch,
  CheckboxGroup as VantCheckboxGroup,
  Checkbox as VantCheckbox,
  Radio as VantRadio,
  RadioGroup as VantRadioGroup,
  Loading as VantLoading,
} from "vant";
// import VConsole from "vconsole";
// new VConsole();
Vue.config.productionTip = false;
Vue.use(Steps);
Vue.use(Step);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Area);
Vue.use(Panel);
Vue.use(Divider);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Badge);
Vue.use(TreeSelect);
Vue.use(RadioButton);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(VantIcon);
Vue.use(DropdownMenu);
Vue.use(Rate);
Vue.use(DropdownItem);
Vue.use(VantCheckboxGroup);
Vue.use(VantCheckbox);
Vue.use(VantRadio);
Vue.use(VantRadioGroup);
Vue.use(Form);
Vue.use(Overlay);
Vue.use(VantLoading);
Vue.use(Image);
Vue.use(VantForm);
Vue.use(FormItem);
Vue.use(Select);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Tabs);
Vue.use(Field);
Vue.use(Picker);
Vue.use(Search);
Vue.use(Loading);
Vue.use(Calendar);
Vue.use(InputNumber);
Vue.use(Link);
Vue.use(Uploader);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Tag);
Vue.use(ContactCard);
Vue.use(Tab);
Vue.use(Option);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Input);
Vue.use(Upload);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DatePicker);
// Vue.use(Message)
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Switch);
Vue.use(VantSwitch);
Vue.use(Drawer);
Vue.use(Empty);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
